// Compliance / disclaimer block — bottom of the research page.
// Copy comes from BE `labCopy` when shipped, with brand-styled defaults.
import { C } from "@/lib/brand";
import { RESEARCH_NAVY, RESEARCH_NAVY_DEEP } from "@/components/research/ResearchHero";

const DEFAULTS = {
  qualityLine: "Batch tested in US labs for identity, purity, and consistency.",
  supplierLine: "Supplied to physicians throughout the United States.",
  researchOnlyLine: "Sold for research purposes.",
};

export default function ComplianceBlock({ labCopy }) {
  const copy = { ...DEFAULTS, ...(labCopy || {}) };
  return (
    <section
      data-testid="research-compliance-block"
      style={{
        background: RESEARCH_NAVY_DEEP,
        color: C.cream,
        padding: "96px 24px",
      }}
    >
      <div style={{ maxWidth: 900, margin: "0 auto" }}>
        <div
          style={{
            fontFamily: '"JetBrains Mono", "IBM Plex Mono", ui-monospace, monospace',
            fontSize: 10,
            letterSpacing: "0.3em",
            color: "rgba(250,246,240,0.55)",
            textTransform: "uppercase",
            marginBottom: 24,
          }}
        >
          ▪ STANDARDS
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: 36 }} className="md:!grid-cols-3">
          <Stat
            label="QUALITY"
            value={copy.qualityLine}
            testId="research-compliance-quality"
          />
          <Stat
            label="DISTRIBUTION"
            value={copy.supplierLine}
            testId="research-compliance-supplier"
          />
          <Stat
            label="DESIGNATION"
            value={copy.researchOnlyLine}
            testId="research-compliance-research-only"
          />
        </div>
        <div
          style={{
            marginTop: 64,
            paddingTop: 24,
            borderTop: "1px solid rgba(255,255,255,0.12)",
            fontSize: 11,
            color: "rgba(250,246,240,0.4)",
            letterSpacing: "0.1em",
            lineHeight: 1.7,
          }}
          data-testid="research-compliance-footnote"
        >
          Certificate of Analysis (COA) is available per batch on request and
          attached to each product card where issued. All compounds are
          manufactured and verified within United States facilities.
        </div>
      </div>
    </section>
  );
}

function Stat({ label, value, testId }) {
  return (
    <div data-testid={testId}>
      <div
        style={{
          fontFamily: '"JetBrains Mono", "IBM Plex Mono", ui-monospace, monospace',
          fontSize: 10,
          letterSpacing: "0.3em",
          color: "rgba(212,194,168,0.85)",
          textTransform: "uppercase",
          marginBottom: 14,
        }}
      >
        {label}
      </div>
      <div style={{ fontSize: 15, lineHeight: 1.6, color: C.cream }}>
        {value}
      </div>
    </div>
  );
}

export { RESEARCH_NAVY, RESEARCH_NAVY_DEEP };
